// extracted by mini-css-extract-plugin
export default {"error-text":"ErrorText_error-text__xkPZH","error-text-dot":"ErrorText_error-text-dot__AoObc"};